import { render, staticRenderFns } from "./BankEffectList.vue?vue&type=template&id=7e4d244b&scoped=true&"
import script from "./BankEffectList.vue?vue&type=script&lang=js&"
export * from "./BankEffectList.vue?vue&type=script&lang=js&"
import style0 from "./BankEffectList.vue?vue&type=style&index=0&id=7e4d244b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4d244b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
